import { render, staticRenderFns } from "./HelpIcon.vue?vue&type=template&id=5f72b7fa&scoped=true&"
import script from "./HelpIcon.vue?vue&type=script&lang=ts&"
export * from "./HelpIcon.vue?vue&type=script&lang=ts&"
import style0 from "./HelpIcon.vue?vue&type=style&index=0&id=5f72b7fa&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/.pnpm/vue-loader@15.10.1_cache-loader@4.1.0_css-loader@3.6.0_lodash@4.17.15_vue-template-compiler@2.6.11_webpack@4.46.0/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5f72b7fa",
  null
  
)

export default component.exports